/***
 * @Author: hippo
 * @Date: 2024-01-15 10:54:37
 * @LastEditors: hippo
 * @LastEditTime: 2024-12-26 23:53:54
 * @Description: 
 * @
 */
import React from 'react'
import OrderPreviewDrawer from '@/components/dialogs/OrderPreviewDrawer'
import CreateOrderDialog from '@/components/dialogs/CreateOrderDialog'
import AssignOrder from '@/components/dialogs/AssignOrderDialog';
import AppealOrder from '@/components/dialogs/AppealOrderDialog';
import ReferralBindingListDialog from '@/components/dialogs/ReferralBindingListDialog'
import ReferralsManagerListDialog from '@/components/dialogs/ReferralsManagerListDialog'
import RetailBindingListDialog from '@/components/dialogs/RetailBindingListDialog'
import RetailManagerListDialog from '@/components/dialogs/RetailManagerListDialog'
import BindReferralDialog from '@/components/dialogs/BindReferralDialog'
import BindRetailReferralDialog from '@/components/dialogs/BindRetailReferralDialog'
import ChangeBalance from '@/components/dialogs/ChangeBalance'
import ManagerExtDialog from '@/components/dialogs/ManagerExtDialog'
import RejectJoinRequestDialog from '@/components/dialogs/RejectJoinRequestDialog'
import RechargeDialog from '@/components/dialogs/RechargeDialog'
import StaffRoles from '@/components/dialogs/StaffRoles'
import ImageViewDialog from '@/components/dialogs/ImageViewDialog'
import NotifyDialog from '@/components/dialogs/NotifyDialog'
import NotifySendDialog from '@/components/dialogs/NotifySendDialog'
import NotifyHistoryDialog from '@/components/dialogs/NotifyHistoryDialog'
import TenantDialog from '@/components/dialogs/tenantInfoDialog'
import ReServiceDialog from '@/components/dialogs/ReServiceDialog'
import CouponDialog from '@/components/dialogs/CouponDialog'
import CouponStatsDialog from '@/components/dialogs/CouponStatsDialog'
import ReferralRuleDialog from '@/components/dialogs/ReferralRuleDialog'
import DeductionDeposit from '@/components/dialogs/DeductionDeposit'
import BannerDialog from '@/components/dialogs/BannerDialog'
export default function dialogInjector() {
  return (
    <>
      <StaffRoles />
      <RechargeDialog />
      <OrderPreviewDrawer />
      <AssignOrder />
      <CreateOrderDialog />
      <ReferralBindingListDialog />
      <ReferralsManagerListDialog/>
      <RetailBindingListDialog />
      <RetailManagerListDialog />
      <BindReferralDialog />
      <BindRetailReferralDialog />
      <ChangeBalance title="调整师傅账户余额" />
      <ManagerExtDialog />
      <RejectJoinRequestDialog title="申请驳回" />
      <AppealOrder />
      <ImageViewDialog />
      <NotifyDialog />
      <NotifySendDialog />
      <NotifyHistoryDialog />
      <TenantDialog />
      <ReServiceDialog />
      <CouponDialog />
      <CouponStatsDialog />
      <ReferralRuleDialog />
      <DeductionDeposit title="扣除保证金" />
      <BannerDialog />
    </>
  )
}
